@if (customerOrder) {
    <div class="customer-order-details__view">
        @if (detailed && customerOrder.service && customerOrder.service.additionalServiceAttributes) {
            <div class="customer-order-details__section">
                <span class="dynamic__text--xs dynamic__text--bold">Informationen zum Restaurant</span>

                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">Name</span>
                    <span class="dynamic__text--xs">{{ customerOrder.service.additionalServiceAttributes.name }}</span>
                </div>

                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">Ort</span>
                    <span class="dynamic__text--xs">
                        {{ customerOrder.service.additionalServiceAttributes.city }},
                        {{ customerOrder.service.additionalServiceAttributes.postcode }}</span
                    >
                </div>

                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">Straße</span>
                    <span class="dynamic__text--xs">{{
                        customerOrder.service.additionalServiceAttributes.street
                    }}</span>
                </div>

                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">Telefnnummer</span>
                    <span class="dynamic__text--xs">{{ customerOrder.service.additionalServiceAttributes.phone }}</span>
                </div>

                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">E-Mail</span>
                    <span class="dynamic__text--xs">{{ customerOrder.service.additionalServiceAttributes.email }}</span>
                </div>
            </div>

            <div class="customer-order-details__separator"></div>
        }

        @if (detailed && customerOrder.customer) {
            <div class="customer-order-details__section">
                <span class="dynamic__text--xs dynamic__text--bold">Kundendaten</span>

                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">Name</span>
                    <span class="dynamic__text--xs"
                        >{{ customerOrder.customer.firstName }} {{ customerOrder.customer.lastName }}</span
                    >
                </div>
                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">E-Mail</span>
                    <span class="dynamic__text--xs">{{ customerOrder.customer.email }}</span>
                </div>
                <div class="customer-order-details__section__item">
                    <span class="dynamic__text--xs">Telefonnummer</span>
                    <span class="dynamic__text--xs">{{ customerOrder.customer.phone }}</span>
                </div>
            </div>

            <div class="customer-order-details__separator"></div>
        }

        @if (detailed && customerOrder.address) {
            <div class="customer-order-details__section">
                <span class="dynamic__text--xs dynamic__text--bold">Zustelladresse</span>
                <span class="dynamic__text--xs">{{ customerOrder.address.city }}</span>
                <span class="dynamic__text--xs">{{ customerOrder.address.street }}</span>
                <span class="dynamic__text--xs">{{ customerOrder.address.postcode }}</span>
                @if (customerOrder.address.extra) {
                    <span class="dynamic__text--xs dynamic__text--bold">{{ customerOrder.address.extra }}</span>
                }
            </div>

            <div class="customer-order-details__separator"></div>
        }

        <span class="dynamic__text--xs dynamic__text--bold">Bestellung #{{ customerOrder.id }}</span>

        <div class="customer-order-details__products">
            @for (orderProduct of customerOrder.orderProducts; track orderProduct) {
                <span class="customer-order-details__products__quantity dynamic__text--xs dynamic__text--bold"
                    >{{ orderProduct.quantity }}x</span
                >

                <div class="customer-order-details__item">
                    <div class="customer-order-details__products__options">
                        <span class="dynamic__text--xs dynamic__text--bold"
                            >{{ orderProduct.product.name }}
                            @if (orderProduct.product.discount) {
                                <span>(-{{ orderProduct.product.discount }} %)</span>
                            }
                        </span>

                        @for (option of orderProduct.optionGroupSelections[0].selectedOptions; track option) {
                            <span class="dynamic__text--xxs">{{ option.name }}</span>
                        }
                    </div>
                    <span class="customer-order-details__item__no-shrink dynamic__text--xs dynamic__text--bold">
                        <span>{{
                            commonService.formatPriceString(orderProduct.product.price * orderProduct.quantity)
                        }}</span>
                        @for (option of orderProduct.optionGroupSelections[0].selectedOptions; track option) {
                            <span class="dynamic__text--xxs dynamic__text--end">{{
                                commonService.formatPriceString(option.price)
                            }}</span>
                        }
                    </span>
                </div>
            }
        </div>

        <div class="customer-order-details__separator"></div>

        <div class="customer-order-details__prices">
            <div class="customer-order-details__item">
                <span class="dynamic__text--xs">Zwischensumme</span>
                <span class="dynamic__text--xs">{{ commonService.formatPriceString(customerOrder.total) }}</span>
            </div>
            <div class="customer-order-details__item">
                <span class="dynamic__text--xs dynamic__text--bold">Gesamt (inkl. MwSt.)</span>
                <span class="customer-order-details__item__no-shrink dynamic__text--xs dynamic__text--bold">{{
                    commonService.formatPriceString(customerOrder.total)
                }}</span>
            </div>
        </div>

        <div class="customer-order-details__separator"></div>

        <div class="customer-order-details__section">
            <span class="dynamic__text--xs dynamic__text--bold">Zustellungsart</span>
            <span class="dynamic__text--xs">{{ getOrderTypeText(customerOrder.type) }}</span>
        </div>

        <div class="customer-order-details__separator"></div>

        @if (detailed && customerOrder.paymentType) {
            <div class="customer-order-details__section">
                <span class="dynamic__text--xs dynamic__text--bold">Abholzeit</span>
                <span class="dynamic__text--xs">{{
                    customerOrder.asapDelivery
                        ? 'Schnellstmögliche'
                        : commonService.formatFixedOrderTimeString(customerOrder.takeawayTime)
                }}</span>
            </div>

            <div class="customer-order-details__separator"></div>
        }

        <div class="customer-order-details__section__item">
            <div class="customer-order-details__payment">
                <span class="dynamic__text--xs dynamic__text--bold">Bezahlt mit</span>
                <span class="dynamic__text--xs">{{ commonService.formatPaymentType(customerOrder.paymentType) }}</span>
            </div>

            @if (!detailed) {
                <span class="dynamic__button" (click)="navigateToOrderOverview()">Übersicht</span>
            }
        </div>
    </div>
}
